"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileClient = void 0;
var downloadjs_1 = __importDefault(require("downloadjs"));
var helpers_1 = require("src/helpers");
var errors_1 = require("src/errors");
var models_1 = require("src/models");
var clients_1 = require("src/clients");
var buildUploadURLs = function (fileId, revisionId) { return ({
    appURL: "domo/data-files/v1/".concat(fileId).concat(revisionId ? "/revisions/".concat(revisionId) : ''),
    instanceURL: "api/data/v1/data-files/".concat(fileId).concat(revisionId ? "/revisions/".concat(revisionId) : ''),
}); };
var FileClient = /** @class */ (function () {
    function FileClient() {
    }
    FileClient.prototype.upload = function (file, name, description, isPublic, timeout) {
        if (description === void 0) { description = ''; }
        if (isPublic === void 0) { isPublic = true; }
        return __awaiter(this, void 0, void 0, function () {
            var formData, params, url, headers, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(0, helpers_1.isBoolean)(isPublic)) {
                            throw new errors_1.InvalidParamError();
                        }
                        formData = new FormData();
                        formData.append('file', file);
                        params = new URLSearchParams();
                        params.set('name', name.toString());
                        params.set('description', description.toString());
                        params.set('public', isPublic.toString());
                        url = models_1.EndpointsV1.file.toString();
                        headers = {
                            accept: models_1.DataFormatTypes.json,
                        };
                        return [4 /*yield*/, clients_1.TransportClient.post(url, formData, headers, timeout, params.toString())];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, __assign(__assign({}, result), { data: __assign(__assign({}, result.data), buildUploadURLs(result.data.dataFileId)) })];
                }
            });
        });
    };
    FileClient.prototype.uploadRevision = function (file, fileId, timeout) {
        if (timeout === void 0) { timeout = 0; }
        return __awaiter(this, void 0, void 0, function () {
            var formData, url, headers, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        formData = new FormData();
                        formData.append('file', file);
                        url = "".concat(models_1.EndpointsV1.file.toString(), "/").concat(fileId);
                        headers = {
                            accept: models_1.DataFormatTypes.json,
                        };
                        return [4 /*yield*/, clients_1.TransportClient.put(url, formData, headers, timeout)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, __assign(__assign({}, result), { data: __assign(__assign({}, result.data), buildUploadURLs(fileId, result.data.revisionId)) })];
                }
            });
        });
    };
    FileClient.prototype.detailsList = function (ids, expand) {
        if (ids === void 0) { ids = []; }
        if (expand === void 0) { expand = []; }
        if (!(0, helpers_1.isExpandTypeArray)(expand))
            throw new errors_1.InvalidParamError();
        var params = new URLSearchParams();
        if (ids.length !== 0) {
            params.set('ids', ids.join(','));
        }
        if (expand.length !== 0) {
            params.set('expand', expand.join(','));
        }
        var url = "".concat(models_1.EndpointsV1.file.toString(), "/details/");
        return clients_1.TransportClient.get(url, params.toString(), {
            accept: models_1.DataFormatTypes.json,
        });
    };
    FileClient.prototype.download = function (fileId, filename, revisionId) {
        var url = "".concat(models_1.EndpointsV1.file.toString(), "/").concat(fileId).concat(Boolean(revisionId) ? "/revisions/".concat(revisionId) : '');
        return clients_1.TransportClient.getBlob(url, undefined, {
            accept: models_1.DataFormatTypes.json,
        })
            .then(function (data) {
            (0, downloadjs_1.default)(data, filename);
        })
            .catch(function () {
            // eslint-disable-next-line no-console
            console.error('Unable to download file');
        });
    };
    FileClient.prototype.delete = function (fileId, revisionId) {
        var url = "".concat(models_1.EndpointsV1.file.toString(), "/").concat(fileId, "/revisions/").concat(revisionId);
        return clients_1.TransportClient.delete(url, undefined, {
            accept: models_1.DataFormatTypes.json,
        });
    };
    FileClient.prototype.getPermissions = function (fileId) {
        var url = "".concat(models_1.EndpointsV1.file.toString(), "/").concat(fileId, "/permissions");
        return clients_1.TransportClient.get(url, undefined, {
            accept: models_1.DataFormatTypes.json,
        });
    };
    FileClient.prototype.updatePermissions = function (fileId, data) {
        var url = "".concat(models_1.EndpointsV1.file.toString(), "/").concat(fileId, "/permissions");
        return clients_1.TransportClient.put(url, data, { accept: models_1.DataFormatTypes.json });
    };
    return FileClient;
}());
exports.FileClient = FileClient;
exports.default = new FileClient();
